import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = null;

// ==============================|| SLICE - FACILITY ||============================== //

const facilitySlice = createSlice({
  name: "facility",
  initialState,
  reducers: {
    setFacilities(state, action) {
      return action.payload;
    },
    addFacility(state, action) {
      if (state === null) {
        return [action.payload];
      }
      return [...state, action.payload];
    },
    updateFacility(state, action) {
      if (state === null) return state;
      return state.map((facility) =>
        facility._id === action.payload._id ? action.payload : facility
      );
    },
    deleteFacility(state, action) {
      if (state === null) return state;
      return state.filter((facility) => facility._id !== action.payload);
    },
    getActiveFacilities(state) {
      return state;
    },
  },
});

export default facilitySlice.reducer;

export const {
  setFacilities,
  addFacility,
  updateFacility,
  deleteFacility,
  getActiveFacilities,
} = facilitySlice.actions;

// Legacy action type constants for backward compatibility during migration
export const FACILITY_ACTION_TYPES = {
  SET_FACILITIES: "facility/setFacilities",
  ADD_FACILITY: "facility/addFacility",
  UPDATE_FACILITY: "facility/updateFacility",
  DELETE_FACILITY: "facility/deleteFacility",
  GET_ACTIVE_FACILITIES: "facility/getActiveFacilities",
};
